import React from 'react';
import Quill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

export default ({ value, onChange, ...props }) => (
  <Quill value={value || ''} onChange={onChange} {...props} />
);
